export default [
    'title',
    'description',
    'published',
    'featured',
    'coverImage',
    'youtube',
    'deactivated',
    'externalurl',
    'externalurldisplaytext',
    'interests',
    'tags',
    'likes',
    'categoryIds',
];
